import { useAuthStore } from '@/stores/authStore';
import { DoctorAuth0Provider } from './DoctorAuth0Provider';
import { ParentAuth0Provider } from './ParentAuth0Provider';
import { Logout } from '@/pages/Logout';
import { useSearchParams } from 'react-router-dom';

/**
 * Smart logout wrapper that uses the correct Auth0 provider based on user type
 */
export function SmartLogout() {
  const [searchParams] = useSearchParams();
  const { userType } = useAuthStore();
  const storedUserType = localStorage.getItem('userType');
  
  // First check URL parameter (most reliable)
  let effectiveUserType = searchParams.get('type');
  
  // Fallback to store/localStorage
  if (!effectiveUserType) {
    effectiveUserType = userType || storedUserType;
  }
  
  // Check the referrer as another fallback
  if (!effectiveUserType && document.referrer) {
    if (document.referrer.includes('/doctor')) {
      effectiveUserType = 'doctor';
    }
  }

  console.log('[SmartLogout] Determined user type:', effectiveUserType);

  if (effectiveUserType === 'doctor') {
    return (
      <DoctorAuth0Provider>
        <Logout />
      </DoctorAuth0Provider>
    );
  }

  // Default to parent provider
  return (
    <ParentAuth0Provider>
      <Logout />
    </ParentAuth0Provider>
  );
}
